import { useState } from 'react';
import { faqs } from '@/mocks/memes';
import SectionHeader from './SectionHeader';

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <SectionHeader
          kicker="❓ 高频问答"
          title="关于存图、投稿与版权"
          desc="用图前先看这里，收藏、二创、投稿的规矩一次说清。还有别的疑问，直接走页脚“投稿 / 求图”找仓库君。"
        />

        <div className="space-y-3.5">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className={`overflow-hidden rounded-2xl bg-background-50 ring-1 transition-colors ${isOpen ? 'ring-primary-300' : 'ring-background-200'}`}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-[15px] font-bold text-foreground-900">{f.q}</h3>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'}`}>
                    <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i>
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}